import { Controller } from "stimulus"
export default class extends Controller {
    business_control(event) {

        var businessSettings = { days: [] };
        $("span[id^=rangeval_mor_0_]").each(function( i ) {

            var mor_1 = $("span[id=rangeval_mor_1_"+i.toString()+"]")[0].innerText;
            var mor_2 = $("span[id=rangeval_mor_2_"+i.toString()+"]")[0].innerText;
            var mor_3 = $("span[id=rangeval_mor_3_"+i.toString()+"]")[0].innerText;
            var aft_0 = $("span[id=rangeval_aft_0_"+i.toString()+"]")[0].innerText;
            var aft_1 = $("span[id=rangeval_aft_1_"+i.toString()+"]")[0].innerText;
            var aft_2 = $("span[id=rangeval_aft_2_"+i.toString()+"]")[0].innerText;
            var aft_3 = $("span[id=rangeval_aft_3_"+i.toString()+"]")[0].innerText;
            var eve_0 = $("span[id=rangeval_evening_0_"+i.toString()+"]")[0].innerText;
            var eve_1 = $("span[id=rangeval_evening_1_"+i.toString()+"]")[0].innerText;
            var eve_2 = $("span[id=rangeval_evening_2_"+i.toString()+"]")[0].innerText;
            var eve_3 = $("span[id=rangeval_evening_3_"+i.toString()+"]")[0].innerText;
            var ped_eve_0 = $("span[id=rangeval_evening_pedicure_0_"+i.toString()+"]")[0].innerText;
            var ped_eve_1 = $("span[id=rangeval_evening_pedicure_1_"+i.toString()+"]")[0].innerText;
            var ped_eve_2 = $("span[id=rangeval_evening_pedicure_2_"+i.toString()+"]")[0].innerText;
            var ped_eve_3 = $("span[id=rangeval_evening_pedicure_3_"+i.toString()+"]")[0].innerText;
            var biab_eve_0 = $("span[id=rangeval_evening_biab_0_"+i.toString()+"]")[0].innerText;
            var biab_eve_1 = $("span[id=rangeval_evening_biab_1_"+i.toString()+"]")[0].innerText;
            var biab_eve_2 = $("span[id=rangeval_evening_biab_2_"+i.toString()+"]")[0].innerText;
            var biab_eve_3 = $("span[id=rangeval_evening_biab_3_"+i.toString()+"]")[0].innerText;
            var acr_eve_0 = $("span[id=rangeval_evening_acrylic_0_"+i.toString()+"]")[0].innerText;
            var acr_eve_1 = $("span[id=rangeval_evening_acrylic_1_"+i.toString()+"]")[0].innerText;
            var acr_eve_2 = $("span[id=rangeval_evening_acrylic_2_"+i.toString()+"]")[0].innerText;
            var acr_eve_3 = $("span[id=rangeval_evening_acrylic_3_"+i.toString()+"]")[0].innerText;
            var ped_mor_0 = $("span[id=rangeval_mor_pedicure_0_"+i.toString()+"]")[0].innerText;
            var ped_mor_1 = $("span[id=rangeval_mor_pedicure_1_"+i.toString()+"]")[0].innerText;
            var ped_mor_2 = $("span[id=rangeval_mor_pedicure_2_"+i.toString()+"]")[0].innerText;
            var ped_mor_3 = $("span[id=rangeval_mor_pedicure_3_"+i.toString()+"]")[0].innerText;
            var ped_aft_0 = $("span[id=rangeval_aft_pedicure_0_"+i.toString()+"]")[0].innerText;
            var ped_aft_1 = $("span[id=rangeval_aft_pedicure_1_"+i.toString()+"]")[0].innerText;
            var ped_aft_2 = $("span[id=rangeval_aft_pedicure_2_"+i.toString()+"]")[0].innerText;
            var ped_aft_3 = $("span[id=rangeval_aft_pedicure_3_"+i.toString()+"]")[0].innerText;
            var biab_mor_0 = $("span[id=rangeval_mor_biab_0_"+i.toString()+"]")[0].innerText;
            var biab_mor_1 = $("span[id=rangeval_mor_biab_1_"+i.toString()+"]")[0].innerText;
            var biab_mor_2 = $("span[id=rangeval_mor_biab_2_"+i.toString()+"]")[0].innerText;
            var biab_mor_3 = $("span[id=rangeval_mor_biab_3_"+i.toString()+"]")[0].innerText;
            var biab_aft_0 = $("span[id=rangeval_aft_biab_0_"+i.toString()+"]")[0].innerText;
            var biab_aft_1 = $("span[id=rangeval_aft_biab_1_"+i.toString()+"]")[0].innerText;
            var biab_aft_2 = $("span[id=rangeval_aft_biab_2_"+i.toString()+"]")[0].innerText;
            var biab_aft_3 = $("span[id=rangeval_aft_biab_3_"+i.toString()+"]")[0].innerText;

            // Nieuwe acrylic variabelen
            var acr_mor_0 = $("span[id=rangeval_mor_acrylic_0_"+i.toString()+"]")[0].innerText;
            var acr_mor_1 = $("span[id=rangeval_mor_acrylic_1_"+i.toString()+"]")[0].innerText;
            var acr_mor_2 = $("span[id=rangeval_mor_acrylic_2_"+i.toString()+"]")[0].innerText;
            var acr_mor_3 = $("span[id=rangeval_mor_acrylic_3_"+i.toString()+"]")[0].innerText;
            var acr_aft_0 = $("span[id=rangeval_aft_acrylic_0_"+i.toString()+"]")[0].innerText;
            var acr_aft_1 = $("span[id=rangeval_aft_acrylic_1_"+i.toString()+"]")[0].innerText;
            var acr_aft_2 = $("span[id=rangeval_aft_acrylic_2_"+i.toString()+"]")[0].innerText;
            var acr_aft_3 = $("span[id=rangeval_aft_acrylic_3_"+i.toString()+"]")[0].innerText;

            businessSettings.days.push(
                {
                    day: document.getElementById("day_"+i.toString()).value,
                    morning_slots_0: this.innerText,
                    morning_slots_1: mor_1,
                    morning_slots_2: mor_2,
                    morning_slots_3: mor_3,
                    afternoon_slots_0: aft_0,
                    afternoon_slots_1: aft_1,
                    afternoon_slots_2: aft_2,
                    afternoon_slots_3: aft_3,
                    evening_slots_0: eve_0,
                    evening_slots_1: eve_1,
                    evening_slots_2: eve_2,
                    evening_slots_3: eve_3,
                    evening_pedicure_slots_0: ped_eve_0,
                    evening_pedicure_slots_1: ped_eve_1,
                    evening_pedicure_slots_2: ped_eve_2,
                    evening_pedicure_slots_3: ped_eve_3,
                    evening_biab_slots_0: biab_eve_0,
                    evening_biab_slots_1: biab_eve_1,
                    evening_biab_slots_2: biab_eve_2,
                    evening_biab_slots_3: biab_eve_3,
                    evening_acrylic_slots_0: acr_eve_0,
                    evening_acrylic_slots_1: acr_eve_1,
                    evening_acrylic_slots_2: acr_eve_2,
                    evening_acrylic_slots_3: acr_eve_3,
                    morning_pedicure_slots_0: ped_mor_0,
                    morning_pedicure_slots_1: ped_mor_1,
                    morning_pedicure_slots_2: ped_mor_2,
                    morning_pedicure_slots_3: ped_mor_3,
                    afternoon_pedicure_slots_0: ped_aft_0,
                    afternoon_pedicure_slots_1: ped_aft_1,
                    afternoon_pedicure_slots_2: ped_aft_2,
                    afternoon_pedicure_slots_3: ped_aft_3,
                    morning_biab_slots_0: biab_mor_0,
                    morning_biab_slots_1: biab_mor_1,
                    morning_biab_slots_2: biab_mor_2,
                    morning_biab_slots_3: biab_mor_3,
                    afternoon_biab_slots_0: biab_aft_0,
                    afternoon_biab_slots_1: biab_aft_1,
                    afternoon_biab_slots_2: biab_aft_2,
                    afternoon_biab_slots_3: biab_aft_3,
                    morning_acrylic_slots_0: acr_mor_0,
                    morning_acrylic_slots_1: acr_mor_1,
                    morning_acrylic_slots_2: acr_mor_2,
                    morning_acrylic_slots_3: acr_mor_3,
                    afternoon_acrylic_slots_0: acr_aft_0,
                    afternoon_acrylic_slots_1: acr_aft_1,
                    afternoon_acrylic_slots_2: acr_aft_2,
                    afternoon_acrylic_slots_3: acr_aft_3
                }
            )
        });

        let formData = new FormData();
        formData.append("businessSettings", JSON.stringify(businessSettings));

        fetch('/mynails/business/0', {
            body: formData,
            method: 'PUT',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content
             },
        }).then((response) => {
            if (response.redirected || response.status === 401 || response.status === 403) {
                alert("Je sessie is verlopen - log opnieuw in of ververs het scherm.");
                return;
            }
            if (!response.ok) {
                alert("Opslaan mislukt. Probeer het later opnieuw of log opnieuw in of ververs het scherm.");
            }
        }).catch(() => {
            alert("Opslaan mislukt. Controleer je verbinding en probeer opnieuw of log opnieuw in of ververs het scherm.");
        });

    }
}
